import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getBannerList as getBannerListApi,
    addBanner as addBannerApi,
    updateBanner as updateBannerApi,
    deleteBanner as deleteBannerApi
} from "../../../helpers/helper";
import { toast } from "react-toastify";

export const getBannerSlider = createAsyncThunk("Banner/getBannerSlider", async (_, { rejectWithValue }) => {
    try {
        const response = await getBannerListApi({}, { page: 0, size: 500 });
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const addBannerSlider = createAsyncThunk("Banner/addBannerSlider", async (data: any, { rejectWithValue }) => {
    try {
        const response = await addBannerApi(data);
        toast.success("Banner Added Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error("Banner Added Failed", { autoClose: 2000 });
        return rejectWithValue(error);
    }
});

export const updateBannerSlider = createAsyncThunk("Banner/update", async (dataArr: any, { rejectWithValue }) => {
    try {
        const response = await updateBannerApi(dataArr);
        toast.success("Banner Updated Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error("Banner Updated Failed", { autoClose: 2000 });
        return rejectWithValue(error);
    }
});

export const deleteBannerSlider = createAsyncThunk("Banner/deleteBannerSlider", async (bannerId: any, { rejectWithValue }) => {
    try {
        await deleteBannerApi(bannerId);
        toast.success("Banner Deleted Successfully", { autoClose: 2000 });
        return bannerId;
    } catch (error) {
        toast.error("Banner Deleted Failed", { autoClose: 2000 });
        return rejectWithValue(error);
    }
});
